export const XS_SCREEN = 0; // "0px" ==> Xtra small
export const SM_SCREEN = 600; // "600px"  ==> Small
export const MD_SCREEN = 960; // "960px" ==> Medium
export const LG_SCREEN = 1280; // "1280px" ==> Large
export const XL_SCREEN = 1536; // "1536px" ==> Xtra large
